import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
//angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { AgmCoreModule } from '@agm/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ProductBannerComponent } from './product-banner/product-banner.component';
import { SocialComponent } from './social/social.component';
import { CrumbsComponent } from './crumbs/crumbs.component';
import { RecipeComponent } from './recipe/recipe.component';
import { MatInputModule } from '@angular/material/input';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { MatDialogModule } from '@angular/material/dialog';
import { HealthComponent } from './health/health.component';
import { ContactService } from '../services/contact.service';
import { HttpService } from '../services/http.service';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { AlertComponent } from './alert/alert.component';
//ng2-charts


@NgModule( {
  declarations: [
    HeaderComponent,
    FooterComponent,
    ProductBannerComponent,
    SocialComponent,
    CrumbsComponent,
    RecipeComponent,
    HealthComponent,
    AlertComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    NzDrawerModule,
    MatDialogModule,
    NgxSpinnerModule
  ],
  exports: [
    HttpClientModule,
    HeaderComponent,
    FooterComponent,
    ProductBannerComponent,
    CrumbsComponent,
    SocialComponent,
    RecipeComponent,
    HealthComponent,
    BrowserAnimationsModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    NzDrawerModule,
    MatDialogModule,
    NgxSpinnerModule,
    AlertComponent
  ],
  providers: [
    DatePipe,
    ContactService,
    HttpService
  ]
} )
export class SharedModule {}
